/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StuckLockedApplicationsResultDto } from '../models/StuckLockedApplicationsResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StuckLockedApplicationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Dry run: lists stuck applications with a diagnosis, writes nothing.
     * @returns StuckLockedApplicationsResultDto OK
     * @throws ApiError
     */
    public previewStuckLocks(): CancelablePromise<StuckLockedApplicationsResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/StuckLockedApplications/PreviewStuckLocks',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Applies the repairs reported by PreviewStuckLocks.
     * @returns StuckLockedApplicationsResultDto OK
     * @throws ApiError
     */
    public releaseStuckLocks(): CancelablePromise<StuckLockedApplicationsResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/StuckLockedApplications/ReleaseStuckLocks',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Per-row, staff-confirmed repair for the accepted-offer conflict (#1010): an
     * Accepted entry in an Open/Migrated scenario while the application status says
     * otherwise (e.g. accept → hold → back to waitlist). Re-validates everything
     * server-side (the preview row may be stale) and aligns the application to
     * OfferAccepted — the same mutation as the bulk SetOfferAccepted branch. Staff
     * then Mark Housed or record a Strike (which properly voids the acceptance)
     * from the scenario's Vacancy Management panel. Idempotent: an application that
     * is already OfferAccepted/Housed returns 200 without writing anything.
     * @param applicationGuid
     * @returns any OK
     * @throws ApiError
     */
    public restoreOfferAccepted(
        applicationGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/StuckLockedApplications/RestoreOfferAccepted/{applicationGuid}',
            path: {
                'applicationGuid': applicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
